"use client";

import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import data from "@/public/data/flight/flight.peolpeDetails.json";
import Counter from "@/shared/components/common/counter";
import type { ElementType } from "react";
import { Button } from "@/shared/components/common/button";
import { Minus, Plus } from "@phosphor-icons/react/dist/ssr";
import { useDeviceType } from "@/shared/context/DeviceContext";

type PassengerType = {
  adult: number;
  child: number;
  infant: number;
};

interface IPassengerPicker {
  className?: string;
  passengers: PassengerType;
  onClick: (value: PassengerType) => void;
  OnCloseComp?: ElementType;
}

export default function PassengerPicker({
  className,
  passengers,
  onClick,
  OnCloseComp,
}: Readonly<IPassengerPicker>) {
  const deviceType = useDeviceType();
  const handleOnClick = (value: IPerson) => (count: number) => {
    passengers[value] = count;
    onClick(passengers);
  };

  const { options, unit } = data;

  return (
    <Flex className={`w-full flex-col gap-4 p-4 pb-1 ${className}`}>
      {options.map(({ title, desc, value }, i) => (
        <Flex className="justify-between" key={title}>
          <Flex className="flex-col">
            <Typography>{title}</Typography>
            <Typography variant="caption">{desc}</Typography>
          </Flex>
          <Flex className="justify-center items-center">
            <Counter
              onCount={handleOnClick(value as IPerson)}
              format={{ suffix: unit }}
              classNames={{
                counterText: "min-w-fit",
                parent: "flex-nowrap",
                counter: "font-medium",
              }}
              initial={passengers[value as IPerson]}
              buttonPlaceHolders={{
                icons: {
                  increase: <Plus />,
                  decrease: <Minus />,
                },
              }}
              limit={
                value === "adult"
                  ? 9
                  : value === "infant" && passengers["adult"] < 4
                    ? passengers["adult"]
                    : 3
              }
              minLimit={value === "adult" ? 1 : 0}
              total={
                passengers["adult"] + passengers["child"] + passengers["infant"]
              }
              totalLimit={10}
            />
          </Flex>
        </Flex>
      ))}
      {deviceType === "mobile" && OnCloseComp && (
        <Flex className="w-full  justify-end border-t m-0">
          <OnCloseComp asChild>
            <Button className="rounded-xs text-xs  " variant="ghost">
              تایید
            </Button>
          </OnCloseComp>
        </Flex>
      )}
    </Flex>
  );
}
